import React from "react";
import Drawer from "@mui/material/Drawer";
import LoadingButton from "@mui/lab/LoadingButton";
import RightworkSelect from "../../../components/shared/RightworkSelect";
import { BUSINESS_TYPES } from "../../../components/create-company/businessTypes";
import DrawerHeader from "../requests/shared/helpers/DrawerHeader";
import { API_update_onboarding_preferences } from "../../../constants";
import { postRightworkAPI } from "../requests/utilities/requests";

export default function BusinessTypeDrawer({ open, onClose, summary, onSaved }) {
  const savedType = summary?.company?.business_type || "";
  const companyId = summary?.company?.id;
  const [businessType, setBusinessType] = React.useState(savedType);
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState("");
  React.useEffect(() => {
    if (!open) return;
    setBusinessType(savedType);
    setError("");
  }, [open, companyId, savedType]);
  const hasChanges = businessType !== savedType;

  async function save() {
    if (!companyId || !businessType || !hasChanges || saving) return;
    setSaving(true);
    setError("");
    try {
      await postRightworkAPI(API_update_onboarding_preferences, {
        company_id: companyId,
        business_type: businessType,
      });
      await onSaved?.();
      onClose();
    } catch (err) {
      setError(err?.response?.data?.system?.message || "Unable to save business type. Please try again.");
    } finally {
      setSaving(false);
    }
  }

  return <Drawer open={open} anchor="right" onClose={saving ? undefined : onClose}>
    <div className="flex h-full w-[560px] max-w-[100vw] flex-col bg-white">
      <DrawerHeader title="Business type" onClose={saving ? undefined : onClose} />
      <div className="flex-1 overflow-y-auto p-6">
        <p className="mb-5 text-sm text-slate-600">Choose the type that best describes your company.</p>
        <label id="onboarding-business-type-label" htmlFor="onboarding-business-type" className="mb-2 block text-sm font-medium text-slate-700">Business type</label>
        <RightworkSelect id="onboarding-business-type" value={businessType} disabled={saving}
          options={[{ value: "", label: "Choose a business type", disabled: true }, ...BUSINESS_TYPES.map(option => ({ value: option.value, label: option.title }))]}
          onChange={event => setBusinessType(event.target.value)} />
        {error && <p role="alert" className="mt-4 text-sm text-red-600">{error}</p>}
      </div>
      {hasChanges && <div className="border-t border-slate-200 p-6">
        <LoadingButton loading={saving} disabled={!companyId || !businessType} fullWidth variant="contained" onClick={save}
          sx={{ borderRadius: "10px", py: 1.25, textTransform: "none", backgroundColor: "#6d28d9", fontSize: "15px", "&:hover": { backgroundColor: "#5b21b6" }, "&.Mui-disabled": { backgroundColor: "#e2e8f0", color: "#94a3b8" } }}>Save</LoadingButton>
      </div>}
    </div>
  </Drawer>;
}
